import {Injectable, OnInit} from '@angular/core';

@Injectable()
export class GlobalServiceService implements OnInit{
  public width;

  constructor() { }


  ngOnInit(){
  }


  getHeight(proportion: number){
    return this.width * proportion;
  }

  setWidth(width: number){
    this.width = width;
  }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/global-service.service.ts